var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.266 12.257H.733V4.632h2.533v7.627-.002ZM2.001 3.59h-.018C1.132 3.59.582 3.004.582 2.27c0-.732.566-1.318 1.434-1.318.867 0 1.402.57 1.417 1.318 0 .733-.55 1.319-1.434 1.319h.002Zm10.407 8.667H9.873v-4.08c0-1.026-.367-1.725-1.284-1.725-.7 0-1.117.472-1.3.927-.068.163-.084.39-.084.618v4.26H4.67s.033-6.911 0-7.627h2.535v1.081c.336-.518.938-1.259 2.284-1.259 1.668 0 2.919 1.09 2.919 3.432v4.373Z",
  fill: "currentColor"
})));

export default SvgIconLinkedin;